<template>
  <v-col>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title class="pb-8">
            <v-btn
              color="primary"
              @click="CHANGE_RIPARAZIONI_BYTEWOOD_COMPONENT('Insert')"
            >Nuova Riparazione</v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Cerca"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="riparazioni"
            class="elevation-1"
            :search="search"
            :items-per-page="100"
            :footer-props="{
      itemsPerPageAllText: 'Tutti',
      itemsPerPageOptions: [15, 50, 100, -1],
      itemsPerPageText: 'Riparazioni per pagina',
    }"
          >
            <template v-slot:top>
              <edit-form
                :item="selectedItem"
                @edit-submit="triggerSnack($event)"
              />
            </template>

            <template v-slot:item.is_sold="{ item }">
              <v-icon
                color="red"
                v-if="item.is_sold === 0"
              >
                mdi-close
              </v-icon>
              <v-icon
                color="green"
                v-else
              >
                mdi-check
              </v-icon>
            </template>

            <template v-slot:no-data>
              <v-btn
                color="primary"
                @click="fetchRiparazioni"
              >Ricarica</v-btn>
            </template>

            <template v-slot:item.cost="{ item }">
              <span>{{item.cost || '0'}}€</span>
            </template>

            <template v-slot:item.price="{ item }">
              <span>{{item.price || '0'}}€</span>
            </template>

            <template v-slot:item.action="{ item }">
              <td class="actions">
                <v-btn
                  color="orange"
                  elevation="1"
                  outlined
                  small
                  @click.stop="edit(item)"
                >
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  color="red"
                  elevation="1"
                  outlined
                  small
                  @click.stop="triggerDialog(item)"
                >
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </td>
            </template>
            <snack-notification :snack="snack" />
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- dialog -->
    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        max-width="350"
      >
        <v-card>
          <v-card-title class="headline">Cancellare riparazione?</v-card-title>

          <v-card-text>
            Confermando, la riparazione verrà eliminata dal database e le compnenti utilizzate reinserite nel magazzino.
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              text
              @click="remove()"
            >
              Conferma
            </v-btn>

            <v-btn
              color="primary"
              @click="dialog = false"
            >
              Annulla
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-col>
</template>

<script>
  import axios from 'axios'
  import { mapMutations } from 'vuex'

  import EditForm from './EditForm'
  import SnackNotification from './../../SnackNotification'

  export default {
    name: 'Index',
    components: {
      EditForm,
      SnackNotification
    },
    data: () => ({
      search: '',
      dialog: false,
      headers: [
        { text: 'Venduto', value: 'is_sold', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Fornitore', value: 'supplier_name', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'IMEI', value: 'serial_number', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'EAN', value: 'ean', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Brand', value: 'brand', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Modello', value: 'model', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Colore', value: 'color', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'HDD', value: 'disk_space', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'RAM', value: 'ram', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Grado', value: 'grade', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Descrizione', value: 'desctiption', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Costo', value: 'cost', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Prezzo', value: 'price', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: '', value: 'action', class: 'subtitle-2 primary--text font-weight-bold', sortable: 'false' }

      ],
      riparazioni: [],
      item: {},
      snack: {
        error: null,
        visible: null,
        message: null
      },
      config: {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        }
      }
    }),

    computed: {
      selectedItem() {
        return this.item
      }
    },

    methods: {
      ...mapMutations([
        'CHANGE_RIPARAZIONI_BYTEWOOD_COMPONENT',
        'CHANGE_RIPARAZIONI_BYTEWOOD_EDIT'
      ]),

      async fetchRiparazioni() {
        try {

          let {
            data
          } = await axios.get(`${process.env.VUE_APP_API}/repairs/bytewood/fetch`, this.config)

          this.riparazioni = data
        } catch (error) {

          console.log(error)

          this.riparazioni = []
        }
      },

      edit(val) {
        this.item = val
        this.CHANGE_RIPARAZIONI_BYTEWOOD_EDIT(true)
      },

      async remove() {

        const { data } = await axios.post(`${process.env.VUE_APP_API}/v2/repairs/bytewood/delete`, { id: this.item.id }, this.config)

        if (data.status) {
          this.fetchRiparazioni()
          this.dialog = false
        } else {
          alert('Si è verificato un errore.')
        }
      },

      triggerDialog(val) {
        this.item = val
        this.dialog = true
      },

      triggerSnack(e) {
        if (e === 'reset') {

          this.snack = Object.assign({}, {
            error: null,
            visible: null,
            message: null
          })
        } else if (e === 'ok') {

          this.snack = Object.assign({}, {
            visible: true,
            error: false,
            message: 'Riparazione modificata correttamente!'
          })

          this.fetchRiparazioni()
        } else if (e === 'error') {

          this.snack = Object.assign({}, {
            visible: true,
            error: true,
            message: 'Errore nella modifica.'
          })
        }
      }
    },

    async created() {
      await this.fetchRiparazioni()
    },
  }
</script>

<style scoped>
  .actions {
    display: flex;
    flex-flow: row;
    justify-content: flex-end;
    align-items: center;
  }

  .actions > button {
    margin-left: 10px;
  }
</style>